const FormResources = {

    form_data:{
        building_id:        '',
        level_id:           '',
        area_id:            '',
        task_id:            '',
        room_type_id:       '',
        floor_id:           '',
        cost_center_id:     '',
        closed:             '',
        essential_cleaning: '',
        policing:           '',
        project:            '',
        patient:            '',
        exclude_daily:      '',
        work_group:         '',
        exclude_project:    '',
        shift1:             '',
        shift2:             '',
        shift3:             '',
        freq_simbol:        1,
        frequency:          '',
    },

}

export default FormResources